<template>
  <el-drawer
    :visible.sync="purchaseFormModalShow"
    :title="'New Purchase'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    size="80%"
    custom-class="overflow-y-scroll"
  >
    <div class="row" slot="title" style="border-bottom: 1px solid #dddddd">
      <div class="col-12">
        <div class="p-2 my-auto row">
          <div class="col-4 text-center"></div>
          <div class="col-4 text-center">
            <h4 class="m-0 pt-1 text-navy">
              {{ purchase.id ? "Update" : "New" }} Purchase
            </h4>
          </div>
          <div class="col-4 my-auto d-flex justify-content-end">
            <circle-number-indicator :number="'1'" :active="statusCard >= 1" />
            <circle-number-indicator :number="'2'" :active="statusCard >= 2" />
            <circle-number-indicator :number="'3'" :active="statusCard >= 3" />
          </div>
        </div>
      </div>
    </div>
    <div class="row text-warning mb-2" v-if="purchase.purchase_status_id == 2">
      <div class="col-12 px-4">
        This purchase has been submitted to Ottley Capital. Further changes will
        be subject to review and may impact approval timeframes
      </div>
    </div>
    <div v-if="statusCard == 1" class="row small-ui p-3 h-100">
      <div class="col-6 border-right">
        <h2 class="text-center">Invoice</h2>
        <div class="text-center">
          Please upload your purchase invoice to get started
        </div>
        <purchase-invoice-upload
          @continue="onContinue"
          class="p-3"
          :autoUpload="true"
          :invoiceFile="invoiceFile"
          @loading="loadingInvoice = $event"
          :message="''"
        />
        <div class="text-center">
          <h2 class="text-center">Additional documents</h2>
          <el-upload
            action
            :file-list="fileList"
            :on-change="handleUploadAdditional"
            :on-exceed="handleExceed"
            :limit="limit"
            :show-file-list="false"
            multiple
            drag
            :auto-upload="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              pdf,doc,docx,xls,xlsx,csv,txt,rft files
            </div>
          </el-upload>
        </div>
        <div>
          <div
            v-for="(file, index) in fileList"
            v-bind:key="file.uid"
            class="row my-1 text-left"
          >
            <div
              class="col-6"
              :class="
                file.collection_name != 'additional_documents' ? 'd-none' : ''
              "
            >
              <small>{{ file.name }}</small>
            </div>
            <div
              class="col-5"
              :class="
                file.collection_name != 'additional_documents' ? 'd-none' : ''
              "
            >
              <div class="input-group">
                <select
                  class="w-100"
                  size="mini"
                  v-model="file.collection_name"
                >
                  <option
                    v-for="item in documentCategories.filter(
                      (dc) => dc.id == 8
                    )"
                    :key="item.id"
                    :label="item.name"
                    :value="item.collection_name"
                  ></option>
                </select>
              </div>
            </div>
            <div
              class="col-1"
              :class="
                file.collection_name != 'additional_documents' ? 'd-none' : ''
              "
            >
              <el-button
                class="py-1 text-navy"
                type="text"
                @click="onDelete(index)"
                icon="el-icon-close"
              >
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <h2 class="text-center">RFIDs</h2>
        <purchase-rfid-upload
          class="p-3"
          :rfid-data="rfidData"
          @updateFile="updateRfidFile"
        ></purchase-rfid-upload>
      </div>
      <div class="col-12 text-right">
        <el-button
          class="btn-secondary"
          :loading="loadingInvoice"
          @click="statusCard++"
          >Next
        </el-button>
      </div>
    </div>
    <div
      class="row small-ui p-3"
      v-loading="loading"
      v-else-if="statusCard == 2 && !upload_documents"
    >
      <div class="col-lg-6 col-md-12">
        <div class="row py-1">
          <div class="col-5 text-right">
            <span class="font-weight-bold text-navy">Agency</span>
          </div>
          <div class="col-7">
            <el-input
              v-model="initial_business.agency.name"
              disabled
              class="w-100"
            ></el-input>
          </div>
        </div>
        <div class="row py-1">
          <div class="col-5 text-right">
            <span class="font-weight-bold text-navy">Producer</span>
          </div>
          <div class="col-7">
            <el-input
              v-model="initial_business.name"
              disabled
              class="w-100"
            ></el-input>
          </div>
        </div>
        <div class="row py-1">
          <div class="col-5 text-right">
            <span class="font-weight-bold text-navy">Daily Rate </span>
          </div>
          <div class="col-7">
            <el-select
              v-model="purchase.channel_id"
              v-if="channels.length > 0"
              style="width: 90%"
              disabled
              class="w-100"
            >
              <el-option
                v-for="channel in channels"
                :key="channel.id"
                :label="`${$_roundAccurately(channel.daily_rate, 4)}%`"
                :value="channel.id"
              />
            </el-select>
            <span v-else class="text-danger">TBC</span>
          </div>
        </div>
        <div class="row py-1">
          <div class="col-5 text-right">
            <span class="font-weight-bold text-navy">Livestock Class</span>
          </div>
          <div class="col-7">
            <el-select
              v-model="purchase.livestock_class_id"
              :class="`w-100 ${ocr_missing_lc ? 'ocr-missing-input' : ''}`"
              @change="getCategories"
            >
              <el-option :value="1" label="Cattle" />
              <el-option :value="2" label="Sheep" />
            </el-select>
          </div>
        </div>
        <div class="row py-1">
          <div class="col-5 text-right">
            <span class="font-weight-bold text-navy">Purchase Type</span>
          </div>
          <div class="col-7">
            <el-select
              v-model="purchase.purchase_type_id"
              :class="`w-100 ${
                ocr_missing_purchase_type ? 'ocr-missing-input' : ''
              }`"
              placehoder="Select purchase type"
            >
              <el-option
                v-for="t in purchase_types"
                :key="t.id"
                :value="t.id"
                :label="t.name"
              />
            </el-select>
          </div>
        </div>
        <div class="row py-1">
          <div class="col-5 text-right">
            <span class="font-weight-bold text-navy">Nominated PIC</span>
          </div>
          <div class="col-7">
            <el-select
              clearable
              v-model="purchase.property_id"
              :class="`w-100 ${ocr_missing_pic ? 'ocr-missing-input' : ''}`"
              placeholder="Select"
            >
              <el-option
                v-for="item in initial_business.properties.filter(
                  (p) => p.is_approved == true
                )"
                :key="item.id"
                :label="item.pic"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="row py-1">
          <div class="col-5 text-right">
            <span class="font-weight-bold text-navy"
              >Term <small>(max 250 days)</small></span
            >
          </div>
          <div class="col-7">
            <el-autocomplete
              max="250"
              :class="`w-100 ${ocr_missing_term ? 'ocr-missing-input' : ''}`"
              v-model="purchase.agent_advised_term"
              :fetch-suggestions="querySearch"
              placeholder="Please select"
              @select="handleSelect"
              @input="handleSelect"
            >
              <template slot-scope="{ item }">
                <div class="value">{{ item }}</div>
              </template>
            </el-autocomplete>
          </div>
        </div>
        <div class="row py-1">
          <div class="col-5 text-right">
            <span class="font-weight-bold text-navy">Reference</span>
            <el-tooltip
              class="text-success"
              v-if="referenceCodeChecker === 1"
              effect="dark"
              content="Reference Code is available!"
              placement="right"
            >
              <i class="fas fa-check-circle"></i>
            </el-tooltip>
            <el-tooltip
              class="text-danger"
              v-else-if="referenceCodeChecker === 0"
              effect="dark"
              content="Reference Code is in use!"
              placement="right"
            >
              <i class="fas fa-times-circle"></i>
            </el-tooltip>
            <el-tooltip
              class="text-primary"
              v-else-if="referenceCodeChecker === 'loading'"
              effect="dark"
              content="Loading..."
              placement="right"
            >
              <i class="fas fa-spinner fa-spin"></i>
            </el-tooltip>
          </div>
          <div class="col-7">
            <el-input
              v-model="purchase.reference_code"
              :class="`w-100 ${ocr_missing_ref ? 'ocr-missing-input' : ''}`"
              @input="checkIfReferenceCodeIsUnique"
            ></el-input>
          </div>
        </div>
        <div class="row py-1">
          <div class="col-5 text-right">
            <span class="font-weight-bold text-navy">Purchase date</span>
          </div>
          <div class="col-7">
            <el-date-picker
              v-model="purchase.bill_invoice_date"
              value-format="yyyy-MM-dd"
              format="dd/MM/yyyy"
              type="date"
              :class="`w-100 ${
                ocr_missing_purchase_date ? 'ocr-missing-input' : ''
              }`"
              placeholder="Pick a day"
            ></el-date-picker>
          </div>
        </div>
        <div class="row py-1">
          <div class="col-5 text-right">
            <span class="font-weight-bold text-navy"
              >Invoice due date
              <div>
                <small>(Note: This may be subject to change)</small>
              </div>
            </span>
          </div>
          <div class="col-7">
            <el-date-picker
              :picker-options="pickerOptions"
              v-model="purchase.bill_due_date"
              value-format="yyyy-MM-dd"
              format="dd/MM/yyyy"
              type="date"
              :class="`w-100 ${
                ocr_missing_invoice_date ? 'ocr-missing-input' : ''
              }`"
              placeholder="Pick a day"
            ></el-date-picker>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <purchase-document-uploaded
          @show="upload_documents = true"
          :fileList="fileList"
          :media="purchase.media"
        ></purchase-document-uploaded>
        <div class="row h-100">
          <div class="col-lg-12 col-md-5">
            <span class="font-weight-bold text-navy">Notes</span>
          </div>
          <div class="col-lg-12 col-md-7 py-1 h-100">
            <textarea v-model="notes" class="w-100" rows="11"></textarea>
          </div>
        </div>
      </div>
      <div
        class="col-12 d-flex align-items-center justify-content-between py-1"
      >
        <el-button class="btn-secondary" @click="statusCard = 1">
          Previous
        </el-button>

        <div class="d-flex align-items-center justify-content-end w-100">
          <el-button class="btn-primary" @click="validateFields">
            Next
          </el-button>
        </div>
      </div>
    </div>
    <div
      class="small-ui p-3"
      v-loading="loading"
      v-else-if="statusCard == 3 && !upload_documents"
    >
      <div class="row">
        <div class="col-6">
          <div class="row">
            <div class="col-4">
              <span class="font-weight-bold text-navy"
                >Total Invoice Value</span
              >
            </div>
            <div class="col-8 py-1">
              <currency-input v-model="invoice_value_inc" class="w-100" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <purchase-document-uploaded
            @show="upload_documents = true"
            :fileList="fileList"
            :media="purchase.media"
          ></purchase-document-uploaded>
          <div class="row" v-if="false">
            <div class="col-lg-6 col-md-7">
              <span class="font-weight-bold text-navy">Purchase documents</span>
            </div>
            <div class="col-lg-6 col-md-5 py-1">
              <el-button class="btn-secondary" @click="upload_documents = true">
                Upload
              </el-button>
            </div>
          </div>
        </div>
        <div class="col-12 py-3">
          <h3 class="text-navy">Purchase details</h3>
        </div>
        <div class="col-12 pl-4">
          <div class="row">
            <div class="col-2 px-1">
              <span class="font-weight-bold">Head Purchased</span>
            </div>
            <div class="col-3 px-1">
              <span class="font-weight-bold">Description</span>
            </div>
            <!-- <div class="col-2 px-1">
              <span class="font-weight-bold">PIC</span>
            </div> -->
            <div class="col-2 px-1">
              <span class="font-weight-bold">Average weight</span>
            </div>
            <div class="col-5 row">
              <div class="col-3 px-1">
                <span class="font-weight-bold">Total (ex)</span>
              </div>
              <div class="col-3 px-1">
                <span class="font-weight-bold">GST</span>
              </div>
              <div class="col-3 px-1">
                <span class="font-weight-bold">$/Head</span>
              </div>
              <div class="col-2 px-1">
                <span class="font-weight-bold">$/kg (ex)</span>
              </div>
            </div>
          </div>
          <div
            class="row my-1 small-ui"
            v-for="(item, index) in purchase.line_items"
            :key="index"
          >
            <div class="col-2 px-1">
              <span class="font-weight-bold">
                <el-input-number
                  v-model="item.quantity"
                  :controls="false"
                  class="w-100"
                  @input="
                    calculatePrices(item);
                    overallAverageWeight();
                  "
                />
              </span>
            </div>

            <div class="col-3 px-1">
              <el-input
                type="text"
                v-model="item.description"
                class="w-100"
                size="small"
              />
            </div>
            <!-- <div class="col-2 px-1">
              <el-input
                type="text"
                v-model="item.pic"
                class="w-100"
                size="small"
              />
            </div> -->
            <div class="col-2 px-1">
              <el-input-number
                v-model="item.average_weight"
                class="w-100"
                :precision="2"
                :controls="false"
                @change="
                  calculatePrices(item);
                  overallAverageWeight();
                "
              />
            </div>
            <div class="col-5 row">
              <div class="col-3 px-1">
                <span class="font-weight-bold">
                  <currency-input
                    v-model="item.total_ex_gst"
                    class="w-100"
                    @input="calculatePrices(item)"
                  />
                </span>
              </div>
              <div class="col-2 px-1">
                <span class="font-weight-bold">
                  <el-select v-model="item.gst" class="w-100">
                    <el-option label="Yes" :value="1" />
                    <el-option label="No" :value="0" />
                  </el-select>
                </span>
              </div>
              <div class="col-3 px-1">
                <span class="font-weight-bold">
                  <currency-input
                    v-model="item.price_per_head_ex_gst"
                    disabled
                    class="w-100"
                  />
                </span>
              </div>
              <div class="col-3 px-1">
                <span class="font-weight-bold">
                  <currency-input
                    v-model="item.price_per_kg_ex"
                    disabled
                    class="w-100"
                  />
                </span>
              </div>
              <div class="col-1 px-1 text-right mt-1">
                <i
                  class="fa-lg fas fa-times has-interaction"
                  @click="removeItem(item, index)"
                ></i>
              </div>
            </div>
          </div>
          <el-button class="rounded my-3 py-2 text-uppercase" @click="addItem">
            Add Item
          </el-button>
        </div>
        <div class="col-6">
          <div class="row py-1" v-if="shouldShowOverallAverageWeight">
            <div class="col-5">
              <span class="font-weight-bold text-navy">Average Weight</span>
            </div>
            <div class="col-7">
              <el-input-number
                :class="`w-100 ${
                  ocr_missing_average_weight ? 'ocr-missing-input' : ''
                }`"
                :precision="2"
                :controls="false"
                v-model="purchase.average_weight"
                @input="updateAllLineItems"
              />
              <div class="text-muted small mt-1">
                This is an overall average weight. If you update this field it will apply to all line items above. To set individual weights per line item please ensure this field is blank.
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 py-3">
          <hr />
          <span class="font-weight-bold text-navy">Additional costs</span>
        </div>
        <div class="col-12 pl-4">
          <div class="row" v-if="purchase.additional_costs.length > 0">
            <div class="col-4 px-1">
              <span class="font-weight-bold">Description</span>
            </div>
            <div class="col-2 px-1">
              <span class="font-weight-bold">Total (ex)</span>
            </div>
            <div class="col-2 px-1">
              <span class="font-weight-bold">GST</span>
            </div>
          </div>
          <div
            class="row my-1 small-ui"
            v-for="(item, index) in purchase.additional_costs"
            :key="index"
          >
            <div class="col-4 px-1">
              <span class="font-weight-bold">
                <el-input v-model="item.description" class="w-100" />
              </span>
            </div>
            <div class="col-2 px-1">
              <span class="font-weight-bold">
                <currency-input v-model="item.value_ex_gst" class="w-100" />
              </span>
            </div>
            <div class="col-6 row">
              <div class="col-3 px-1">
                <span class="font-weight-bold">
                  <el-select v-model="item.gst" class="w-100">
                    <el-option label="Yes" :value="1" />
                    <el-option label="No" :value="0" />
                  </el-select>
                </span>
              </div>
              <div class="col-1 px-1 text-right mt-1">
                <i
                  class="fa-lg fas fa-times has-interaction"
                  @click="removeAdditionalCost(item, index)"
                ></i>
              </div>
            </div>
          </div>
          <el-button
            class="rounded my-3 py-2 text-uppercase"
            @click="addAdditionalItems"
            >Add additional costs</el-button
          >
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between w-100 mt-3">
        <el-button class="btn-secondary" @click="statusCard = 2"
          >Previous</el-button
        >
        <div>
          <strong>Total Invoice: </strong>
          ${{ $_toLocaleString(purchase.dollar_value, 2) }}
          <el-button
            class="btn-secondary"
            v-if="purchase.purchase_status_id != 2"
            @click="onSubmit(true, purchase.purchase_status_id)"
          >
            Save progress
          </el-button>
          <el-button class="btn-primary ml-2" @click="onSubmit(false, 2)"
            >Send for Approval</el-button
          >
        </div>
      </div>
    </div>
    <div class="row p-3" v-if="upload_documents">
      <div class="col-lg-12 col-md-12 col-sm-12 text-center">
        <el-upload
          action
          :file-list="fileList"
          :on-change="handleUpload"
          :on-exceed="handleExceed"
          :limit="limit"
          :show-file-list="false"
          multiple
          drag
          :auto-upload="false"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            pdf,doc,docx,xls,xlsx,csv,txt,rft files
          </div>
        </el-upload>
      </div>
      <div class="col-lg-12">
        <div
          v-for="(file, index) in fileList"
          v-bind:key="file.uid"
          class="row my-1 text-left"
        >
          <div class="col-6">
            <small>{{ file.name }}</small>
          </div>
          <div class="col-5">
            <div class="input-group">
              <select class="w-100" size="mini" v-model="file.collection_name">
                <option
                  v-for="item in documentCategories"
                  :key="item.id"
                  :label="item.name"
                  :value="item.collection_name"
                ></option>
              </select>
            </div>
          </div>
          <div class="col-1">
            <el-button
              class="py-1 text-navy"
              type="text"
              @click="onDelete(index)"
              icon="el-icon-close"
            >
            </el-button>
          </div>
        </div>
      </div>
      <div class="col-12 text-right mt-2">
        <el-button class="btn-secondary" @click="upload_documents = false"
          >Continue</el-button
        >
      </div>
    </div>
    <!-- keep this to make sure the computed running -->
    <input :value="invoice_value_inc" v-show="false" />
  </el-drawer>
</template>
<script>
import OttleyFormatter from "../../../../mixins/OttleyFormatter";
import Business from "../../../modelsPortal/Business";
import Purchase from "../../../modelsPortal/Purchase";
import Channel from "../../../modelsPortal/Channel";
import PurchaseDocumentCategory from "../../../modelsPortal/PurchaseDocumentCategory";
import BreedCategory from "../../../modelsPortal/BreedCategory";
import Sex from "../../../modelsPortal/Sex";
import Form from "form-backend-validation";
import OCRMixin from "../../../mixins/OCRMixin";
import PurchaseType from "../../../modelsPortal/common/PurchaseType";
import GST from "../../../../mixins/GST";
import PurchaseInvoiceUpload from "./pages/PurchaseInvoiceUpload.vue";
import PurchaseDocumentUploaded from "./pages/PurchaseDocumentUploaded.vue";
export default {
  components: { PurchaseInvoiceUpload, PurchaseDocumentUploaded },
  mixins: [OCRMixin, OttleyFormatter, GST],
  props: {
    initial_business: {
      type: Object,
    },
    initial_purchase: {
      type: Object,
    },
    showFormOnly: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      purchaseFormModalShow: true,
      form: new Form(),
      loading: false,
      loadingInvoice: false,
      purchase: this.initial_purchase ?? {
        seller_name: "x",
        channel_id: null,
        livestock_class_id: null,
        average_weight: null,
        property_id: null,
        agent_advised_term: null,
        reference_code: null,
        bill_invoice_date: null,
        bill_due_date: null,
        notes: null,
        value: 0,
        line_items: [],
        additional_costs: [],
        purchase_status_id: 1,
        purchase_type_id: null,
        ocr_scan_batch_id: null,
        media: [],
      },
      statusCard: this.showFormOnly === true ? 2 : 1,
      channels: [],
      terms: ["60", "90", "120", "180", "250"],
      fileList: [],
      documentCategories: [],
      breedCategories: [],
      sexes: [],
      channel: null,
      items: [],
      limit: 0,
      notes: null,
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
      upload_documents: false,
      purchase_types: [],
      invoice_table_items: [],
      ocr_missing_purchase_type: false,
      ocr_missing_average_weight: false,
      ocr_missing_term: false,
      ocr_missing_pic: false,
      ocr_missing_ref: false,
      ocr_missing_lc: false,
      ocr_missing_purchase_date: false,
      ocr_missing_invoice_date: false,
      referenceCodeChecker: null,
      invoiceFile: null,
      rfidData: null,
      hasInitialIndividualWeights: false,
    };
  },
  async created() {
    this.getLimit();
    this.getNotes();
    await Promise.all([
      this.getPurchaseTypes(),
      this.getBusinessChannels(),
      this.getPurchaseDocumentCategory(),
      this.getCategories(),
    ]);
  },

  methods: {
    validateFields() {
      if (!this.purchase.agent_advised_term) {
        this.$message({
          type: "error",
          message: "The term field is required",
        });
        return;
      }
      let promises = [];
      if (this.purchase.reference_code && this.referenceCodeChecker != 1) {
        promises.push(this.checkIfReferenceCodeIsUnique());
      }
      if (promises.length == 0) {
        if (!this.purchase.reference_code || this.referenceCodeChecker != 1) {
          this.$message({
            type: "error",
            message: "The reference code is required",
          });
          return;
        }
        this.statusCard++;
      } else {
        Promise.all(promises).then((responseList) => {
          if (this.referenceCodeChecker != 1) {
            this.$message({
              type: "error",
              message: "The reference code is required",
            });
            return;
          } else this.statusCard++;
        });
      }
    },
    updateRfidFile(type, data = null) {
      if (type == 1) {
        this.fileList = this.fileList.filter(
          (f) => f.collection_name != "nlis_file_(rfid's)"
        );
        if (data) {
          this.fileList.push(data.file);
          this.rfidData = data;
        }
      } else {
        this.rfidData = null;
      }
    },
    removeAdditionalCost(item, index) {
      this.purchase.additional_costs.splice(index, 1);
    },
    removeItem(item, index) {
      this.purchase.line_items.splice(index, 1);
      this.calculatePrices(item);
      this.overallAverageWeight();
    },
    updateAllLineItems() {
      let self = this;
      this.purchase.line_items.forEach((line) => {
        line.average_weight = self.purchase.average_weight;
      });
    },
    overallAverageWeight() {
      let averageWeight = 0;
      let totalWeight = this.purchase.line_items.reduce((prev, curr) => {
        const lineWeight = curr.quantity * curr.average_weight;
        if (!isNaN(lineWeight)) {
          return prev + lineWeight;
        } else {
          return prev;
        }
      }, 0);

      let total = this.purchase.line_items.reduce((prev, curr) => {
        const value = Number(curr.quantity);
        if (!isNaN(value)) {
          return prev + value;
        } else {
          return prev;
        }
      }, 0);

      if (total > 0) {
        averageWeight = totalWeight / total;
      }
      this.purchase.average_weight = averageWeight;

      return averageWeight;
    },
    async checkIfReferenceCodeIsUnique() {
      this.referenceCodeChecker = "loading";
      let data = { reference_code: this.purchase.reference_code };

      if (this.purchase.id) data.purchase_id = this.purchase.id;

      await axios
        .post(`/api/v2/portal/reference-code`, data)
        .then((res) => {
          if (res.data === "not found" || res.data === "same purchase") {
            this.referenceCodeChecker = 1;
          } else {
            this.referenceCodeChecker = 0;
          }
        })
        .finally((_) => {
          if (this.referenceCodeChecker === "loading")
            this.referenceCodeChecker = null;
        });
    },

    async getPurchaseTypes() {
      try {
        this.purchase_types = await new PurchaseType().get();
      } catch (err) {
        console.error(err);
      }
    },
    onContinue(values) {
      if (values) {
        this.ocr_missing_ref = true;

        // spot the error first
        this.ocr_missing_ref = true; // always hightlight this

        if (!this.purchase.purchase_type_id)
          this.ocr_missing_purchase_type = true;
        // if (!values.reference_code) this.ocr_missing_ref = true;
        if (!values.due_date) this.ocr_missing_invoice_date = true;
        if (!values.invoice_date) this.ocr_missing_purchase_date = true;
        if (!values.term) this.ocr_missing_term = true;
        if (!values.livestock_class_id) this.ocr_missing_lc = true;
        if (!values.nominated_pic) this.ocr_missing_pic = true;

        this.invoice_table_items = values.table_items || [];
        this.purchase.reference_code = null;

        // if (this.purchase.reference_code)
        // this.checkIfReferenceCodeIsUnique(this.purchase.reference_code);

        // this.purchase.invoice_value_inc = values.amount_due || null;
        this.purchase.bill_due_date = values.due_date
          ? new Date(values.due_date)
          : null;

        this.purchase.bill_invoice_date = values.invoice_date
          ? new Date(values.invoice_date)
          : null;

        this.purchase.agent_advised_term = values.term || null;

        this.purchase.livestock_class_id = values.livestock_class_id || null;

        if (Number(values.average_weight || 0) <= 0) {
          // inject a code to find all average weight from a table -> total weight for all / total heads for all
          if (values.table_items) {
            const totalWeight = values.table_items
              .map((ti) => Number(ti.weight || 0))
              .reduce((sum, a) => sum + a, 0);
            const totalHeads = values.table_items
              .map((ti) => Number(ti.qty || 0))
              .reduce((sum, a) => sum + a, 0);

            if (totalHeads > 0) {
              this.ocr_missing_average_weight = false;
              this.purchase.average_weight = Number(
                totalWeight / totalHeads
              ).toFixed(4);
            } else this.ocr_missing_average_weight = true;
          } else this.ocr_missing_average_weight = true;
        } else {
          this.ocr_missing_average_weight = false;
          this.purchase.average_weight = Number(values.average_weight).toFixed(
            4
          ); // the average weight
        }

        // add the file here
        if (values.file) {
          this.fileList = this.fileList.filter(
            (f) => f.collection_name != "invoice"
          );
          this.fileList.push(values.file);
          this.invoiceFile = values.file;
        }
        // add new line item with number of heads
        if (this.purchase.livestock_class_id) {
          // need to track sheep or cattle
          if (values.table_items) {
            let lineItems = values.table_items.sort((a, b) => a.id - b.id);
            this.purchase.line_items = lineItems.map((tableItem) => {
              let price_per_head_ex_gst = tableItem.price_per_head || undefined;
              let price_per_kilo = tableItem.price_per_kilo || undefined;
              const qty = Number(tableItem.qty || 0);
              const exgst = Number(tableItem.amount || 0);
              if (!price_per_head_ex_gst) {
                price_per_head_ex_gst = qty > 0 ? exgst / qty : 0;
              }

              price_per_kilo =
                Number(tableItem.avg_weight || 0) > 0 && qty > 0
                  ? exgst / qty / Number(tableItem.avg_weight)
                  : 0;

              return {
                // pic: tableItem.buyer_pic || tableItem.vendor_pic || null,
                livestock_class_id: this.purchase.livestock_class_id,
                sex_id: tableItem.sex_id || null,
                breed_category_id: tableItem.breed_category_id || null,
                quantity: qty,
                description: tableItem.description || "",
                price_per_kg_ex: price_per_kilo || 0,
                price_per_head_ex_gst: price_per_head_ex_gst,
                total_ex_gst: tableItem.amount || 0,
                average_weight: tableItem.avg_weight || 0,
                gst: Number(tableItem.tax || 0) > 0 ? 1 : 0,
              };
            });
            
            // Check if OCR detected individual weights for line items
            const individualWeights = this.purchase.line_items.map(item => Number(item.average_weight || 0));
            const uniqueWeights = [...new Set(individualWeights.filter(weight => weight > 0))];
            this.hasInitialIndividualWeights = uniqueWeights.length > 1 || 
              (uniqueWeights.length === 1 && uniqueWeights[0] !== Number(this.purchase.average_weight || 0));
          }
        }

        if (values.ocr_scan_batch_id)
          this.purchase.ocr_scan_batch_id = values.ocr_scan_batch_id;

        // prefile the pic / property id
        if (values.nominated_pic) {
          const property = this.initial_business.properties.find(
            (property) => property.pic === values.nominated_pic
          );

          if (property) {
            this.purchase.property_id = property.id;
            this.ocr_missing_pic = false;
          } else {
            this.ocr_missing_pic = true;
          }
        }
      }

      //this.statusCard += 1;
    },
    disabledDate(date) {
      let dayOfWeek = moment(date).day();
      return moment().add(2, "days") > date || [0, 6].includes(dayOfWeek);
    },
    getNotes() {
      this.notes =
        this.purchase &&
        this.purchase.client_comment &&
        this.purchase.client_comment.length > 0
          ? this.purchase.client_comment[0].message
          : "";
    },
    getLimit() {
      this.limit =
        5 -
        (this.purchase && this.purchase.media ? this.purchase.media.length : 0);
    },
    calculatePrices(item) {
      if (item.quantity) {
        item.price_per_head_ex_gst = item.total_ex_gst / item.quantity;
        /*if (item.average_weight == 0) {
          item.average_weight = this.purchase.average_weight;
        }*/
        item.price_per_kg_ex =
          item.average_weight > 0 && item.quantity > 0
            ? item.total_ex_gst / item.quantity / item.average_weight
            : 0;
      }
    },
    uploadDocuments(transaction) {
      if (this.fileList.length == 0) return;
      let form_data = new FormData();
      this.fileList.forEach((document) => {
        form_data.append(`attachments[]`, document.raw, document.name);
        if (document.collection_name)
          form_data.append("collection_name[]", document.collection_name);

        if (this.rfidData && this.rfidData.file) {
          form_data.append(
            "rfidHeader[]",
            this.rfidData.file.rfidHeader ? this.rfidData.file.rfidHeader : ""
          );
        }

        form_data.append("media_status_id[]", 2);
        form_data.append("transaction", transaction);
      });

      axios
        .post(
          `/api/v2/portal/businesses/${this.initial_business.id}/purchases/${this.purchase.id}/upload`,
          form_data,
          {
            headers: { "content-type": "multipart/form-data" },
          }
        )
        .then((res) => {
          this.purchase.media = res.data.media;
          this.fileList = [];
        })
        .catch((errors) => {
          var errorText = "";
          console.log("Upload files");
          console.log(errors);
          _.forEach(errors.response.data.errors, function (value) {
            errorText += "" + value + " ";
          });
          this.$message({
            type: "error",
            message: errorText,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`You can upload 5 files`);
    },
    onSubmit: function (progress, status = 1, action = "") {
      if (status == 2) {
        this.rfids = this.fileList.filter(
          (f) => f.collection_name == "nlis_file_(rfid's)"
        ).length;
        this.invoice = this.fileList.filter(
          (f) => f.collection_name == "invoice"
        ).length;
        this.rfidsMedia = 0;
        this.invoiceMedia = 0;

        if (this.purchase.media && this.purchase.media.length > 0) {
          this.rfidsMedia = this.purchase.media.filter(
            (f) => f.collection_name == "nlis_file_(rfid's)"
          ).length;
          this.invoiceMedia = this.purchase.media.filter(
            (f) => f.collection_name == "invoice"
          ).length;
        }
        let errorText = [];
        if (this.invoice == 0 && this.invoiceMedia == 0) {
          errorText.push("Invoice required to submit purchase");
        }
        if (
          this.rfids == 0 &&
          this.rfidsMedia == 0 &&
          this.purchase.livestock_class_id == 1
        ) {
          errorText.push("RFIDs required to submit purchase");
        }
        if (errorText.length > 0) {
          this.$message({
            type: "error",
            message: errorText.join(" "),
          });
          return;
        }
      }
      if (status == 2 && action == "proceed") {
        this.statusCard++;
        return;
      }

      if (this.referenceCodeChecker !== 1 && !this.purchase.id) {
        let msg =
          "This invoice reference number has already been submitted to Ottley!";
        if (!this.purchase.reference_code)
          msg = "This invoice reference number is required";
        this.$message.error(msg);
        return;
      }
      this.loading = true;
      this.purchase.progress = progress;
      this.purchase.notes = this.notes;
      let purchase = { ...this.purchase };
      purchase.purchase_status_id = status;
      this.purchase.line_items = this.purchase.line_items.map((item) => {
        item.price_per_head_ex_gst = parseFloat(
          item.price_per_head_ex_gst
        ).toFixed(4);
        item.price_per_kg_ex = parseFloat(item.price_per_kg_ex).toFixed(4);
        item.total_ex_gst = parseFloat(item.total_ex_gst).toFixed(4);
        item.average_weight = parseFloat(item.average_weight).toFixed(4);
        return item;
      });

      new Purchase(purchase)
        .for(new Business(this.initial_business))
        .save()
        .then((res) => {
          let transaction = true;
          if (this.purchase.purchase_status_id == 1) transaction = false;
          this.purchase = res;
          this.uploadDocuments(transaction);
          if (progress || status == 2)
            this.$message.success("Successfully saved!");
          else this.statusCard++;
          if (status == 2) {
            this.$emit("close");
          }
        })
        .catch((errors) => {
          var errorText = [];
          _.forEach(errors.response.data.errors, function (value) {
            errorText.push(value[0]);
          });
          errorText = [...new Set(errorText)];
          this.$message({
            type: "error",
            message: errorText.join(" "),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    querySearch(queryString, cb) {
      cb(this.terms);
    },
    async getBusinessChannels() {
      new Channel()
        .for(new Business(this.initial_business))
        .get()
        .then((res) => {
          this.channels = res;
          if (this.channels.length > 0) {
            this.channel = this.channels[0];
            this.purchase.channel_id = this.channel.id;
            if (
              this.channel.term_category_id == 2 &&
              !this.purchase.agent_advised_term
            ) {
              this.purchase.agent_advised_term = "250";
            }
          }
        })
        .catch((errors) => {
          this.$message.error(errors.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getPurchaseDocumentCategory() {
      new PurchaseDocumentCategory()
        .whereIn("id", [5, 6, 8])
        .get()
        .then((res) => {
          this.documentCategories = res;
        })
        .catch((errors) => {
          this.$message.error(errors.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCategories() {
      if (this.purchase.livestock_class_id) {
        this.getSex();
        this.getBreedCategory();
      }
    },
    async getBreedCategory() {
      new BreedCategory()
        .where("livestock_class_id", this.purchase.livestock_class_id)
        .get()
        .then((res) => {
          this.breedCategories = res;
        })
        .catch((errors) => {
          this.$message.error(errors.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getSex() {
      new Sex()
        .where("livestock_class_id", this.purchase.livestock_class_id)
        .get()
        .then((res) => {
          this.sexes = res;
        })
        .catch((errors) => {
          this.$message.error(errors.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleUpload(file) {
      file.collection_name = "additional_documents";

      this.documentCategories.forEach((category) => {
        if (category.search_terms) {
          let fileName = file.name
            .replace(/[&\/\\#,+()$~%.'":*?<>{}-]/g, " ")
            .toLowerCase();
          let result = category.search_terms.some((word) => {
            return fileName.includes(word.toLowerCase());
          });
          let total = this.fileList.filter(
            (fl) => fl.collection_name == category.collection_name
          ).length;
          if (result && total == 0) {
            file.collection_name = category.collection_name;
          }
        }
      });
      /*this.fileList = this.fileList.filter(
        (fl) => fl.collection_name != file.collection_name,
      );*/

      this.fileList.push(file);
    },
    handleUploadAdditional(file) {
      file.collection_name = "additional_documents";

      this.fileList.push(file);
    },
    onDeleteMedia(media) {
      if (!media.id) return;
      axios
        .post(
          `/api/v2/portal/businesses/${this.initial_business.id}/purchases/${this.purchase.id}/delete-file`,
          { media_id: media.id }
        )
        .then((res) => {
          this.purchase.media = res.data.media;
          this.$message.success("File deleted!");
        })
        .catch((errors) => {
          var errorText = "";
          _.forEach(errors.response.data.errors, function (value) {
            errorText += "" + value + " ";
          });
          this.$message({ type: "error", message: errorText });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onDelete(file) {
      this.fileList.splice(file, 1);
    },
    handleSelect(item) {
      if (item > 250) this.purchase.agent_advised_term = "250";
      else this.purchase.agent_advised_term = item;
      console.log(this.purchase.agent_advised_term);
    },
    addItem() {
      const newItem = {
        livestock_class_id: this.purchase.livestock_class_id,
        sex_id: null,
        breed_category_id: null,
        quantity: 0,
        description: "",
        price_per_kg_ex: 0,
        price_per_head_ex_gst: 0,
        total_ex_gst: 0,
        average_weight: this.shouldShowOverallAverageWeight ? (this.purchase.average_weight || 0) : 0,
        gst: 1,
      };
      this.purchase.line_items.push(newItem);
    },
    handleValueChange(item, value) {
      item.value_inc_gst = this.calculateIncludingGst(value);
    },
    addAdditionalItems() {
      this.purchase.additional_costs.push({
        description: "",
        value_ex_gst: 0,
        value_inc_gst: 0,
        gst: 1,
      });
    },
    handleClose(done) {
      if (this.purchase.id) {
        this.$emit("close");
        done();
      } else {
        this.$confirm(
          "This purchase will be lost by exiting this page. Are you sure you want to continue?"
        )
          .then((_) => {
            this.$emit("close");
            done();
          })
          .catch((_) => {});
      }
    },
  },
  watch: {
    "purchase.purchase_type_id"(newVal, oldVal) {
      if (newVal && this.ocr_missing_purchase_type) {
        this.ocr_missing_purchase_type = false;
      }
    },
    "purchase.property_id"(newVal, oldVal) {
      if (newVal && this.ocr_missing_pic) {
        this.ocr_missing_pic = false;
      }
    },
    "purchase.average_weight"(newVal, oldVal) {
      if (newVal && this.ocr_missing_average_weight) {
        this.ocr_missing_average_weight = false;
      }
    },
    "purchase.agent_advised_term"(newVal, oldVal) {
      if (newVal && this.ocr_missing_term) {
        this.ocr_missing_term = false;
      }
    },
    "purchase.reference_code"(newVal, oldVal) {
      if (newVal && this.ocr_missing_ref) {
        this.ocr_missing_ref = false;
      }
    },
    "purchase.livestock_class_id"(newVal, oldVal) {
      if (newVal && this.ocr_missing_lc) {
        this.ocr_missing_lc = false;
      }
    },
    "purchase.bill_due_date"(newVal, oldVal) {
      if (newVal && this.ocr_missing_invoice_date) {
        this.ocr_missing_invoice_date = false;
      }
    },
    "purchase.bill_invoice_date"(newVal, oldVal) {
      if (newVal && this.ocr_missing_purchase_date) {
        this.ocr_missing_purchase_date = false;
      }
    },
  },
  computed: {
    invoice_value_inc() {
      let lines = 0;
      let costs = 0;

      if (this.purchase.line_items.length > 0) {
        lines = this.purchase.line_items.reduce((prev, curr) => {
          if (curr.total_ex_gst) {
            return prev + Number(curr.total_ex_gst) * (curr.gst ? 1.1 : 1);
          } else {
            return prev;
          }
        }, 0);
      }

      if (this.purchase.additional_costs.length > 0) {
        costs = this.purchase.additional_costs.reduce((prev, curr) => {
          // value_ex_gst is a non gst item amount
          if (curr.gst) {
            // if gst applied that means it will be added with the gst value of it
            return prev + Number(curr.value_ex_gst) * 1.1;
          } else {
            // if gst is false; then just add the value
            return prev + Number(curr.value_ex_gst);
          }
        }, 0);
      }

      this.purchase.bill_value_inc = this.purchase.dollar_value =
        this.$_roundAccurately(Number(lines || 0) + Number(costs || 0), 4);

      this.purchase.value = this.purchase.dollar_value * 100;
      return this.purchase.dollar_value;
    },
    shouldShowOverallAverageWeight() {
      // Show overall average weight field if:
      // 1. There are no line items yet, OR
      // 2. Line items didn't initially have individual weights from OCR
      if (this.purchase.line_items.length === 0) {
        return true;
      }
      
      // Hide the field if OCR initially detected individual weights
      return !this.hasInitialIndividualWeights;
    },
  },
};
</script>
<style>
.required-flag {
  color: red;
  font-size: 18px;
}

.ocr-missing-input,
.ocr-missing-input > input,
.ocr-missing-input > div > input {
  border-color: #409eff !important;
  background-color: #e5f4fb !important;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
</style>
